<template>
  <div>
    <omk-button
      v-if="whitelabel.omDesign"
      @click="requestACall()"
      :button-type="computedButtonType"
      :button-size="isMobile ? 'small' : 'medium'"
      :disabled="isButtonDisabled || buttonLoading"
      class="request-a-call-btn"
    >
      Request A Call
    </omk-button>
    <v-btn
      v-else
      depressed
      outlined
      rounded
      color="primary"
      class="ml-0"
      :loading="buttonLoading"
      :disabled="isButtonDisabled"
      @click="requestACall()"
    >
      Request A Call
    </v-btn>

    <ErrorSnackbar v-model="showError" />
    <SuccessSnackbar v-model="showSuccess" :message="successMessage" />
  </div>
</template>

<script>
  import { REQUEST_A_CALL_MUTATION } from '../../constants/graphql/testators';
  import ErrorSnackbar from '../common/ErrorSnackbar.vue';
  import SuccessSnackbar from '../common/SuccessSnackbar.vue';
  import { formHelperMixin } from '../../mixins/form-helper-mixin';

  export default {
    name: 'RequestACallBtn',
    components: {
      ErrorSnackbar,
      SuccessSnackbar,
    },
    mixins: [formHelperMixin],
    data() {
      return {
        showSuccess: false,
        successMessage: null,
        localStorageTimestamp: null,
      };
    },
    methods: {
      requestACall() {
        if (this.isButtonDisabled || this.buttonLoading) return;

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'request-a-call',
          omuserid: this.$store.getters?.userId,
        });

        this.buttonLoading = true;

        this.$apollo
          .mutate({
            mutation: REQUEST_A_CALL_MUTATION,
            variables: {
              testatorId: this.testatorId,
              forInsurance: false,
            },
          })
          .then(response => {
            if (response.data.requestACall) {
              // Set localStorage timestamp when request is successful
              const timestamp = Date.now().toString();
              localStorage.setItem(
                'logged_in_request_a_call_timestamp',
                timestamp
              );
              // Immediately update reactive data to disable button
              this.localStorageTimestamp = timestamp;
              this.showSuccessMessage();
            } else {
              this.displayError();
            }
          })
          .catch(error => {
            this.displayError();
            throw error;
          });
      },
      showSuccessMessage() {
        this.successMessage =
          'Thank you. One of our specialists will contact you to assist.';
        this.showSuccess = true;
        this.buttonLoading = false;
      },
      checkLocalStorage() {
        this.localStorageTimestamp = localStorage.getItem(
          'logged_in_request_a_call_timestamp'
        );
      },
    },
    computed: {
      computedButtonType() {
        return this.fill ? 'filled-button' : 'outlined-button';
      },
      isMobile() {
        return this.$isMobileDevice();
      },
      isButtonDisabled() {
        if (!this.localStorageTimestamp) return false;

        const currentTime = Date.now();
        const timeSinceLastRequest =
          currentTime - parseInt(this.localStorageTimestamp);
        const oneHourInMs = 60 * 60 * 1000; // 1 hour in milliseconds
        return timeSinceLastRequest < oneHourInMs;
      },
    },
    mounted() {
      this.checkLocalStorage();
    },
  };
</script>

<style lang="scss" scoped>
  .request-a-call-btn {
    margin-right: 15px;
  }
</style>
